import { HttpClient, HttpEventType } from '@angular/common/http';
import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { Config } from 'datatables.net';
import { ToastrService } from 'ngx-toastr';
import { forkJoin, map, Subject } from 'rxjs';
import { ApiServiceListService } from 'src/app/_services/api/api-service-list.service';
import { ActionType, ITable, TableRequest } from 'src/app/model/table.model';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-offer-list',
    templateUrl: './offer-list.component.html',
    styleUrl: './offer-list.component.css',
    standalone: false
})
export class OfferListComponent {
  public breadcrumb: any;
  options = {
    close: false,
    expand: false,
    minimize: false,
    reload: false
  };
  dtOptions: Config = {};
  dtTrigger: Subject<any> = new Subject<any>();
  closeResult = '';
  model: any = {};
  rows: any;


  currentModuleName = this.route.snapshot.data['module'];
  constructor(private route:ActivatedRoute,public loader: LoadingBarService, private apiService: ApiServiceListService, private router: Router, private modalService: NgbModal, private toastr: ToastrService) {
    this.breadcrumb = {
      'mainlabel': 'Offer Management',
    };
    this.dtOptions = {
      pagingType: 'full_numbers',
      searching: true,
      //  paging:false
      lengthChange: true,
      language: {
        searchPlaceholder: 'Search offer'
      }
    }
    // this.getOffers();
    this.getOffersFullDetails();
  }



  @ViewChild('itemDeleteModal') itemDeleteModal!: any;

  columnList = [];
  tableData = [];
  pageInfo: TableRequest = {
    pageSize: 10,
    currentPage: 1,
    totalCount: 0,
    filteredValue: [],
    searchValue: '',
    sortColumn: '',
    sortOrder: 'asc'
  }
  actionItems: ActionType[] = [];
  filterFields = [];
  actionType = ActionType;

  pageInfoChange(data) {
    this.pageInfo = data;
    this.getOffers();
  }


  getOffersFullDetails() {
    const filterInfo$ = this.apiService.getOfferFilterDetails();
    const getOffersList$ = this.apiService.getOffersAPI({ body: this.pageInfo });

    // Combine both observables
    forkJoin([filterInfo$, getOffersList$]).subscribe(
      {
        next: ([filterInfo, tableData]) => {
          if (filterInfo) {
            this.filterFields = filterInfo.data.filterFields;
            this.actionItems = filterInfo.data.actionItems;
            this.columnList = filterInfo.data.columnList;
          }
          if (tableData) {
            this.tableData = tableData.data.tableData;
            this.pageInfo.totalCount = tableData.data.pageInfo.totalCount;
          }
        },
        error: (error) => {
          console.error('Error:', error);
        }
      }
    );
  }


  getOffers() {
    let parameter: any = {
      body: this.pageInfo
    }
    this.loader.increment(35);
    this.apiService.getOffersAPI(parameter).subscribe({
      next: (value: ITable) => {
        // Handle emitted values
        if (value.data.tableData) {
          this.tableData = value.data.tableData;
          this.pageInfo.totalCount = value.data.pageInfo.totalCount;

        } else {
          this.tableData = [];
          this.pageInfo.totalCount = 0;
        }

      },
      error: (error: any) => {
        // Handle errors
      },
      complete: () => {
        this.loader.complete();
      }
    });
  }


  actionEvent(data) {
    if (data.type == this.actionType.UPDATE) {
      this.editItem(data.value._id);
    }
    if (data.type == this.actionType.DELETE) {
      this.deleteItemCheck(this.itemDeleteModal, data.value._id);
    }
  }

  editItem(id: string) {
    this.router.navigateByUrl('/offer/create/' + id);
  }

  deleteItemCheck(deleteModal: any, id) {
    let self = this;

    self.modalService.open(deleteModal, { ariaLabelledBy: 'modal-basic-title', keyboard: false, backdrop: 'static', size: 'sm', centered: true }).result.then((result) => {
      console.log("self.selectObj", result);
      if (result == 'Ok click') {
        this.deleteItem(id);
      } else {
        this.closeResult = `Dismissed ${this.getDismissReason(result)}`;
      }
    }, (reason) => {
      console.log("close");

      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  deleteItem(id) {
    let body: any = {};
    body = { "group": id }
    // return;
    this.apiService.deleteOfferAPI(body).subscribe({
      next: (response: any) => {
        console.log(response);
        if (response.success) {
          this.toastr.success(response.message, '', {
            timeOut: 3000,
          });
          this.getOffers();
        } else {
          this.toastr.error(response.message, '', {
            timeOut: 3000,
          });
        }
      },
      error: (error) => {

      }
    });
  }

  moveToAdd() {
    this.router.navigateByUrl('/offer/create');
  }

  private getDismissReason(reason: any): string {
    console.log(reason);

    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }
}
